module.exports = __webpack_public_path__ + "img/HOMECREDIT.578592b8.svg";